import React, { useCallback, useEffect, useRef, useState } from "react";
import "../CheckboxDropDown/CheckboxDropDown.css";
import "./BriefCheckboxDropdown.css";
import { Globals as OldGlobals} from "../../global/Globals";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../context/Languagecontext";
const BriefCheckboxDropdown = ({
  title,
  isOpen,
  options,
  onToggle,
  onSelectAll,
  onSelect,
  selectedValues,
  selectedItems,
  dropdownRef,
  isDatePicker,
  selectedMonthYear,
  selectedMonthYearText,
  onDateChange,
  zIndex,
  width,
  className,
  boxLength = 40, // Default value of 40, can be overridden by props
  search,
}) => {
const { Globals } = useLanguage();
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [itemsToShow, setItemsToShow] = useState(100);
  const [searchText, setSearchText] = useState("");
  const containerRef = useRef(null);
  const debounceTimeout = useRef(null);
    const isSearching = searchText.trim() !== "";
    const location = useLocation();

    useEffect(() => {
      if (options && searchText.trim().length < 3) {
        setVisibleOptions(options.slice(0, itemsToShow));
      }
    }, [itemsToShow, options]);

    const handleScroll = () => {
      const container = containerRef.current;
      if (searchText.trim().length < 3) {
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 10) {
        // Load next 100 if available
        if (itemsToShow < options.length) {
          setItemsToShow((prev) => prev + 100);
        }
      }
    }
    };
    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearchText(value);
    
        if (debounceTimeout.current) {
          clearTimeout(debounceTimeout.current);
        }
    
        debounceTimeout.current = setTimeout(() => {
          if (value.trim() === "") {
            setVisibleOptions(options.slice(0, itemsToShow));
          }else if (value.trim().length >= 3) {
            const filtered = options.filter((option) =>
              option.name.toLowerCase().includes(value.toLowerCase())
              // or use startsWith for prefix matching:
              // option.name.toLowerCase().startsWith(value.toLowerCase())
            );
            setVisibleOptions(filtered);
          } else {
            // If less than 3 characters, show limited/default results or empty
            setVisibleOptions(options.slice(0, itemsToShow));
          }
        }, 300); // Adjust debounce delay (300ms here) as needed
      }, [options]);

    const isAllSelected = !isDatePicker
    ? isSearching
      ? visibleOptions.length > 0 && visibleOptions.length === selectedValues.length
      : options.length > 0 && options.length === selectedValues.length
    : "";
    

  const selectedValuesAsNumbers = !isDatePicker
    ? selectedValues.map((e) => e.id)
    : [];

  function joinArrayWithCustomSeparator(array) {
    if (array.length === 0) return "";
    if (array.length === 1) return array[0];

    const allButLast = array.slice(0, -1).join(", ");
    const last = array[array.length - 1];

    return `${allButLast}, ${last}`;
  }
  const getDisplayText = () => {
    if (isDatePicker) {
      return selectedMonthYearText.length > 0 ? selectedMonthYearText : title;
    }
    if (!selectedValues || selectedValues.length === 0) {
      return title;
    }

    if (selectedValues.length > 2) {
      const firstTwoValue = selectedValues.map((e) => e.name).slice(0, 2);
      return `${firstTwoValue.join(", ")} + ${selectedValues.length - 2}`;
    }

    return selectedValues.map((e) => e.name).join(", ");
  };

  const onDropdownClick=() =>{
    onToggle();
    if (options) {
      setVisibleOptions(options.slice(0, itemsToShow));
    }
    setSearchText(""); // Clear search text when toggling dropdown
  }

  return (
    <div
      className={`dropdown ${
        selectedValues.length
          ? "create-brief-dropdown-selected"
          : "create-brief-dropdown"
      }  ${className}`}
      ref={dropdownRef}
      style={{ zIndex }}
    >
      <div className="dropdown-title" onClick={onDropdownClick}>
        <div
          className="create-brief-checkbox-title"
          data-placeholder={selectedValues.length}
        >
          {getDisplayText()}
        </div>
        <div className="dropdown-img">
          <img
            className="dropdown-img"
            src={
              isDatePicker ? OldGlobals.IMG.CALENDER_ICON : OldGlobals.IMG.DROPDOWN
            }
            alt="dropdown-icon"
          />
        </div>
      </div>
      {isOpen && !isDatePicker && (
        <div
          className={`dropdown-content ${className} create-brief-dropdown-override-300`}
          style={{ width }}
          ref={containerRef}
        >
           {search && (
                      <div className="searchBox-wrapper">
                      <div className="searchBox_dropdown">
                        <input
                          type="text"
                          placeholder={Globals.SEARCH_MIN_3_CHAR}
                          className="searchInput_dropdown"
                          value={searchText}
                          onChange={handleSearch}
                        />
                        {/* <div className="searchIcon" onClick={handleSearch}>
                          <img className="search_dropdown_icon" src={Globals.IMG.SEARCH} />
                        </div> */}
                      </div>
                    </div>
                    )}

          <div className="dropdownItem-warpper"  onScroll={handleScroll}> 
          {console.log("visibleoptions",visibleOptions)}   
          { location.pathname != '/raise-ticket' && visibleOptions.length > 1 && (      
          <div key="Select-All" className="dropdownItem">
            <input
              type="checkbox"
              id="selectall"
              value="SelectAll"
              className="filter_checkbox"
              checked={isAllSelected}
              onChange={() => onSelectAll(!isAllSelected,  searchText.trim() === "" ? options : visibleOptions)}
            />
            <label htmlFor="selectall" className="option-label">
               {Globals.CHECKDROPDOWN.SELECTALL}
            </label>
          </div>
          )}

          {location.pathname != '/raise-ticket' && visibleOptions.map((option) => (
            <div key={option.id} className="dropdownItem">
              <input
                type="checkbox"
                id={option.id}
                value={option.id}
                className="filter_checkbox"
                checked={selectedValues.map((e) => e.id).includes(option.id)}
                onChange={() => onSelect(option)}
              />
              <label htmlFor={option.id} className="option-label">
                {option.name}
              </label>
            </div>
          ))}
          {searchText.trim() !== "" &&  visibleOptions.length === 0 && (
              <div className="filter-search-no-results dropdownItem">
                {Globals.NO_RESULTS}
                </div>
                )}
        </div>
        </div>
      )}
      {isOpen && isDatePicker && (
        <div className="dropdownDatepick">
          <div className="month-pick">
            <DatePicker
              selected={new Date()}
              onChange={onDateChange}
              placeholderText={Globals.SELECT_MONTH_YEAR}
              maxDate={new Date()}
              inline
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BriefCheckboxDropdown;
